if(screen.width <= 768) {
  $( document ).ready(function() {
      $('.instagramSlider').slick({
      slidesToShow: 4,
      dots: false,
      arrows: false,arrows: false,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 4
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            slidesToShow: 1,
            centerMode: true,
          }
        }
      ]
    });
  });
}
